<template>
    <div>
        <div class="page-lead mb-3">
            Przeglądaj ważne dokumenty związane z akceptacją promocji oraz
            Twojej współpracy z Producentami.
        </div>
        <div class="row">
            <div class="col-md-3">
                <the-filters
                    @applyFilters="applyFilters"
                    :filters="filters"
                    :moduleName="'documents'"
                />
            </div>
            <div class="col-md-9">
                <div class="c-page-headline">
                    <h1 class="c-page-headline__title">
                        Ustawienia/ Dokumenty
                    </h1>
                    <div class="c-settings-count">
                        <span v-if="totalRecords && status === 'idle'">{{
                            totalRecords | plurals('wynik', 'wyniki', 'wyników')
                        }}</span>
                    </div>
                </div>
                <div class="c-settings">
                    <div
                        class="
                            c-settings-filters
                            mt-2 mt-md-0
                            w-100
                            justify-content-between
                        "
                    >
                        <sort-component
                            :text="'Sortuj po:'"
                            :moduleName="'documents'"
                            :options="$store.getters.getDocumentsSortOptions"
                        ></sort-component>
                        <results-per-page
                            :per-page="paging.perPage"
                            :text="'Pokazuj na stronie:'"
                            :on-change="changeResultsPerPage"
                        ></results-per-page>
                    </div>
                </div>
                <page-preloader v-if="status === 'loading'"></page-preloader>

                <div
                    v-else-if="documents && documents.length > 0"
                    class="content"
                >
                    <section class="richTable richTableDocuments">
                        <div class="richTable-head">
                            <div
                                class="richTable-head-col"
                                style="--width-md: 35%; --width-lg: 40%"
                            >
                                Nazwa dokumentu
                            </div>
                            <div
                                class="richTable-head-col"
                                style="--width-md: 15%"
                            >
                                Obowiązuje od
                            </div>
                            <div
                                class="richTable-head-col"
                                style="--width-md: 20%; --width-lg: 15% "
                            >
                                Obowiązuje do
                            </div>
                            <div
                                class="richTable-head-col"
                                style="--width-md: 15%"
                            >
                                <span> Usługa </span>
                            </div>
                            <div
                                class="richTable-head-col"
                                style="--width-md: 15%"
                            >
                                <span> Akcje </span>
                            </div>
                        </div>
                        <div class="richTable-body">
                            <div
                                class="richTable-row text-primary"
                                v-for="(doc, idx) in documents"
                                :key="`doc-${idx}`"
                            >
                                <div
                                    class="richTable-col"
                                    style="--width: 50% ; --width-md: 35% ; --width-lg: 40% "
                                >
                                    <div class="richTable-headline">
                                        Nazwa dokumentu
                                    </div>
                                    <div
                                        class="richTableDocuments__documentName"
                                    >
                                        {{ doc.name }}
                                    </div>
                                </div>
                                <div
                                    class="richTable-col"
                                    style="--width: 50%; --width-md: 15%"
                                >
                                    <div class="richTable-headline">
                                        Obowiązuje od
                                    </div>
                                    <div>
                                        {{
                                            $moment(doc.activeFrom).format(
                                                'DD-MM-YYYY'
                                            )
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="richTable-col"
                                    style="--width: 50% ;--width-md: 20%;--width-lg: 15%"
                                >
                                    <div class="richTable-headline">
                                        Obowiązuje do
                                    </div>
                                    <div>
                                        {{
                                            doc.archivedAt
                                                ? $moment(
                                                      doc.archivedAt
                                                  ).format('DD-MM-YYYY')
                                                : '-'
                                        }}
                                    </div>
                                </div>
                                <div
                                    class="richTable-col"
                                    style="--width: 50%; --width-md: 15%"
                                >
                                    <div class="richTable-headline">Usługa</div>
                                    <div>{{ doc.serviceName }}</div>
                                </div>
                                <div
                                    class="richTable-col"
                                    style="--width: 100%; --width-md: 10%"
                                >
                                    <button
                                        @click="
                                            $functions.downloadFile(
                                                doc.minioLink,
                                                doc.name
                                            )
                                        "
                                        download
                                        class="btn btn-sm btn-outline-custom"
                                    >
                                        <a-icon icon="Download" />
                                        <span class="ml-1"> Pobierz </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </section>
                    <the-pagination
                        :current="paging.page"
                        :total="paging.totalPages"
                        :perPage="paging.perPage"
                        :on-change="onChange"
                    ></the-pagination>
                </div>
                <div v-else>Brak wyników</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        applyFilters(e) {
            this.fetch()
        },
        async changeResultsPerPage(perPage) {
            await this.$store.dispatch('setDocumentsPerPage', perPage)
            this.fetch()
        },
        fetch() {
            this.$store.dispatch('documentsFetch')
        },
        onChange(page) {
            this.$router.push({
                query: { ...this.$route.query, page: page }
            })
        }
    },
    created() {
        this.fetch()
    },
    computed: {
        filters() {
            return this.$store.getters.getDocumentsFilters
        },
        documents() {
            return this.$store.getters.getDocuments
        },
        status() {
            return this.$store.getters.getDocumentsStatus
        },
        paging() {
            return this.$store.getters.getDocumentsPaging
        },
        totalRecords() {
            return this.paging.totalRecords
        }
    }
}
</script>
